import { createHighlightPlugin } from '@udecode/plate'

export default () => createHighlightPlugin()
